export const MODULES = {
  ANALYTICS_DASHBOARD: "analytics_dashboard",
  CATEGORIES: "categories",
  BRAND: "brand",
  USERS: "users",
  PRODUCTS: "products",
  ORDERS: "orders",
  RETURNS: "returns",
  PAYMENTS: "payments",
  LOGS_TRACKING: "logs_tracking",
  NEWSLETTER: "newsletter",
  DISPUTES: "disputes",
  QUERIES: "queries",
  CMS: "cms",
  NOTIFICATIONS: "notifications",
  PROFILE: "profile",
  PASSWORD: "change_password",
  STAFFS: "staffs",
  SIZES: "sizes",
  BULK_UPLOAD: "bulk_upload",
  //   BIDS: "bids",
  //   STORE: "store",
  //   BADGES: "badges",
  //   AWARDS: "awards",
  //   STAFF: "staff",
};
